import { LogoSize, useTokenContext } from '@silo/ui';
import { useSiloWeb3 } from '@silo/web3';
import { AssetLogo } from '../silo/common/icons/AssetLogo';
import { getChecksumAddressOrThrow } from '@silo/types';

interface TokenLogoProps {
  size: LogoSize;
}

export function TokenLogo({ size }: TokenLogoProps): JSX.Element {
  const { tokenAddress } = useTokenContext();
  const { protocolKey } = useSiloWeb3();
  const address = getChecksumAddressOrThrow(tokenAddress);

  return <AssetLogo protocolInstance={protocolKey} address={address} size={size} />;
}
